"use strict";
var passwordRevealButtons = document.querySelectorAll('.reveal-password');
var togglePasswordField = function () {
    var passwordField = this.parentElement.parentElement.previousElementSibling;
    if (passwordField) {
        passwordField.getAttribute('type') === 'password'
            ? passwordField.setAttribute('type', 'text')
            : passwordField.setAttribute('type', 'password');
    }
    this.parentElement.classList.toggle('bg-info');
};
for (var i = passwordRevealButtons.length - 1; i >= 0; i--) {
    passwordRevealButtons[i].addEventListener('click', togglePasswordField);
}
